import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners } = args;
  // const RCSelectionChange = listeners["selection-change"] || function () { };
  // 课程表
  function studentsManage(onlineClass) {

    router.push({
      path: "/dataTraining/classSchedule",
      query: { id: onlineClass.uuid, childId: onlineClass.classChildId },
    });
  }
  // 学员考勤
  function goClassGroup(onlineClass) {
    router.push({
      path: "/dataTraining/attendance",
      query: { classId: onlineClass.uuid, childId: onlineClass.classChildId },
    });
  }
  // 作业管理
  function noticeList(onlineClass) {
    router.push({
      path: "/dataTraining/jobManagement",
      query: { classId: onlineClass.uuid, childId: onlineClass.classChildId },
    });
  }

  // 测试管理
  function fileLibraryList(onlineClass) {
    router.push({
      path: "/dataTraining/testManage",
      query: { classId: onlineClass.uuid, childId: onlineClass.classChildId },
    });
  }

  function fullMarkCheck(onlineClass) {
    router.push({
      path: "/dataTraining/fullMarkCheck",
      query: { classId: onlineClass.uuid, childId: onlineClass.classChildId },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    const dealConf = [
      ["icon_kechengbiao_icon", "课程表", () => studentsManage(onlineClass), ""],
      // ["icon_kaoqin_icon", "学员考勤", () => goClassGroup(onlineClass), ""],
      ["icon_zuoy_icon", "作业管理", () => noticeList(onlineClass), ""],
      ["icon_cesh_icon", "测试管理", () => fileLibraryList(onlineClass), ""],
      ["iconfont icxueyuanshuzihuaxiang iconfont-adapt", "学员数字画像", () => fullMarkCheck(onlineClass), ""],
    ]
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "小班名称",
      showOverflowTooltip: true,
      prop: "className",
      minWidth: "400",
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "200",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
